import React from "react";
import styled from "styled-components";

import { Fade } from "react-awesome-reveal";

// Components
import ServiceBox from "../Elements/ServiceBoxWC";

// Assets

export default function Services() {
  const cards = [
    {
      icon: "fa-user-gear",
      colorStyle: "var(--wc-main-secondary)",
      title: "Gestión de Alumnos",
      description:
        "Administrá fácilmente tu base de datos de estudiantes. Registrá nuevos alumnos, editá perfiles y mantené un seguimiento completo de cada uno.",
    },
    {
      icon: "fa-user-check",
      colorStyle: "var(--wc-main-primary)",
      title: "Autoservicio para Alumnos",
      description:
        "Tus alumnos podrán reservar, cancelar y reprogramar clases de forma independiente, reduciendo tu carga administrativa.",
    },
    {
      icon: "fa-calendar",
      colorStyle: "var(--wc-main-secondary)",
      title: "Calendario Flexible",
      description:
        "Configurá clases únicas o recurrentes según tus necesidades. Adaptá tu horario de enseñanza a cualquier modalidad.",
    },
    {
      icon: "fa-palette",
      colorStyle: "var(--wc-main-primary)",
      title: "Personalización Total",
      description:
        "Dale identidad propia a tu plataforma con tu logo, colores corporativos y elementos visuales que representen tu marca.",
    },
    {
      icon: "fa-envelope-open",
      colorStyle: "var(--wc-main-secondary)",
      title: "Comunicación Automática",
      description:
        "Mantené a tus alumnos informados con notificaciones automáticas de confirmaciones, recordatorios y cambios de horario.",
    },
    {
      icon: "fa-chart-line",
      colorStyle: "var(--wc-main-primary)",
      title: "Analytics Avanzados",
      description:
        "Obtené insights valiosos sobre asistencia, pagos y rendimiento para optimizar tu negocio y tomar mejores decisiones.",
    },
  ];

  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Funcionalidades</h1>
          </HeaderInfo>
          <ServiceBoxRow
            style={{ alignItems: "center", justifyContent: "center" }}
          >
            <Fade cascade damping={0.15} className="flex">
              {cards.map((card, i) => {
                return (
                  <ServiceBoxWrapper key={card.title}>
                    <ServiceBox
                      icon={card.icon}
                      title={card.title}
                      subtitle={card.description}
                      colorStyle={card.colorStyle}
                    />
                  </ServiceBoxWrapper>
                );
              })}
            </Fade>
          </ServiceBoxRow>
        </div>
        {/* <div className="lightBg">
          <div className="container">
            <Fade direction="right">
              <Advertising className="flexSpaceCenter">
                <AddLeft>
                  <h4 className="font15 semiBold">
                    Unas palabras sobre Tu Taller
                  </h4>
                  <h2 className="font40 extraBold">La app para tu taller</h2>
                  <hr />
                  <p className="font12">
                    Nuestra misión es brindar una app para que emprendedores,
                    docentes y profesionales inviertan menos tiempo en
                    gestionando sus talleres y cursos.
                  </p>
                  <ButtonsRow
                    className="flexNullCenter"
                    style={{ margin: "30px 0" }}
                  >
                    <div style={{ width: "190px" }}>
                      <FullButton
                        title="Probá la App ahora"
                        action={() => navigate("/home/create")}
                      />
                    </div>
                    <div style={{ width: "190px", marginLeft: "15px" }}>
                      <FullButton
                        title="Contactanos"
                        border
                        action={() =>
                          scroller.scrollTo("contact", {
                            spy: true,
                            smooth: true,
                          })
                        }
                      />
                    </div>
                  </ButtonsRow>
                </AddLeft>
                <AddRight>
                  <AddRightInner>
                    <div className="flexNullCenter">
                      <AddImgWrapp1 className="flexCenter">
                        <img src={AddImage1} alt="office" />
                      </AddImgWrapp1>
                      <AddImgWrapp2>
                        <img src={AddImage2} alt="office" />
                      </AddImgWrapp2>
                    </div>
                    <div className="flexNullCenter">
                      <AddImgWrapp3>
                        <img src={AddImage3} alt="office" />
                      </AddImgWrapp3>
                      <AddImgWrapp4>
                        <img src={AddImage4} alt="office" />
                      </AddImgWrapp4>
                    </div>
                  </AddRightInner>
                </AddRight>
              </Advertising>
            </Fade>
          </div>
        </div> */}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2em 0;
  gap: 20px;
  
  @media (max-width: 1200px) {
    padding: 1.5em 0;
  }
  
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 1em 0;
    gap: 0;
  }
`;

const ServiceBoxWrapper = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 0 auto;
  
  @media (max-width: 1200px) {
    min-width: 280px;
    max-width: 350px;
  }
  
  @media (max-width: 860px) {
    width: 100%;
    max-width: 100%;
    min-width: auto;
    text-align: center;
    padding: 30px 20px;
    margin: 10px 0;
  }
  
  @media (max-width: 480px) {
    padding: 20px 10px;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;